import { sdk as imageClientSdk } from '@wix/image-kit';
import { ImageDescriptor } from './ImageDescriptor';
import { ImageScaleType } from './ImageSDKConfig';
/**
 * Wrapper class for wix image client API
 */
var ImageSDK = /** @class */ (function () {
    function ImageSDK(image, config) {
        if (config === void 0) { config = {}; }
        this.config = config;
        var imgDescr = new ImageDescriptor(image);
        // save source ratio
        if (!image.targetHeight) {
            image.targetHeight =
                (image.targetWidth / image.sourceWidth) * image.sourceHeight;
        }
        this.image = imgDescr.getFullImageDescriptor();
    }
    ImageSDK.prototype.getScaledUrl = function (scaleType) {
        if (scaleType === void 0) { scaleType = ImageScaleType.FILL; }
        var _a = this.image, sourceHeight = _a.sourceHeight, sourceWidth = _a.sourceWidth, relativeUrl = _a.relativeUrl, targetHeight = _a.targetHeight, targetWidth = _a.targetWidth;
        switch (scaleType) {
            case ImageScaleType.FIT:
                // https://github.com/wix-private/wow-libs/blob/162acb19f5db427b5518fc17f524dcdcaefb459b/packages/image-kit/src/sdk/api.ts#L26
                return imageClientSdk.getScaleToFitImageURL(relativeUrl, sourceWidth, sourceHeight, targetWidth, targetHeight, this.config);
            case ImageScaleType.CROP:
                // imageClientSdk.getCropImageURL
                throw new Error('Not implemented method getCropImageDescriptor');
            case ImageScaleType.FILL:
            default:
                return imageClientSdk.getScaleToFillImageURL(relativeUrl, sourceWidth, sourceHeight, targetWidth, targetHeight, this.config);
        }
    };
    return ImageSDK;
}());
export { ImageSDK };
//# sourceMappingURL=ImageSDK.js.map